<template>
    <div id="print" class="big_cat_screen" :style="{'background-color': '#' + backgroundColor}">
        <div class="back_nav" @click="backNav()"><img src="@/assets/back_nav.png"/></div>
        <audio v-show="false" src="https://wxcdn.kdcer.com/al_syb/removal/pao2.wav" controls="controls" preload id="music"></audio>

        <div v-if="showExitConfirm === 1" class="exit_transition">
            <div class="exit_content">
                <div class="exit_title">完成后，才可以获得星星哦</div>
                <div class="game_action">
                    <div class="game_quit" v-on:click.stop="gameQuitClick">
                        <img src="../../Images/game_quit.png"/>
                        <span>Quit</span>
                    </div>
                    <div class="game_continue" v-on:click.stop="gameContinueClick">
                        <img src="../../Images/game_continue.png"/>
                        <span>Continue</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="star_transition" v-if="showStarTransition && starCount > 0">
            <div class="content">
                <div class="content2">
                    <div class="star_show">
                        <div class="icon1"><img id="star_img_1" style="display: none" :src="getStarImg(1)"/></div>
                        <div class="icon2"><img id="star_img_2" style="display: none" :src="getStarImg(2)"/></div>
                        <div class="icon3"><img id="star_img_3" style="display: none" :src="getStarImg(3)"/></div>
                    </div>
                    <div class="star_score">
                        <img class="icon" src="@/assets/star_score_s.png"/><span>+{{starCount}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="star_animation" style="display:none">
            <div class="star_score">
                <img class="icon" src="@/assets/star_score_s.png"/><span>+{{starCount}}</span>
            </div>
        </div>
        <div class="score_content" :style="{top: '20px', right: '30px'}"><img src="../../assets/star_score_s.png"/><span>{{totalStarCount}}</span></div>
        <audio class="audio" :src="starAudio" id="star_audio" @ended="playEnded('star_audio')" @error="playEnded('star_audio')" />

        <audio v-show="false" :src="ccInitUrl" id="cc_init_audio"/>
        <audio v-show="false" :src="ccAudioUrl" id="cc_success_audio"/>

        <!-- 桌面 -->
        <div class="desk_back" :style="{width:deskBackWidth + 'px'}">
            <ul class="desk" id="desk">
                <div class="card open" :style="{background: 'url(' + getWholeThumbnailCut(item.picture, 192, 256) + ') no-repeat', backgroundSize: '96px 128px'}" v-for="(item,index) in listWordPicture" :key="index" @click="fclick($event, item.picture, item.audio)">
                    <i :id="item.pk" class="fa_common" />
                </div>
            </ul>
        </div>

    </div>

</template>

<script>
    import $ from "jquery";

    function transformView() {
        var width = document.documentElement.clientWidth;
        var height = document.documentElement.clientHeight;

        var vPrint =  $('#print');
        if( width > height ){
            //竖屏
            vPrint.width(width);
            vPrint.height(height);
            vPrint.css('top', 0);
            vPrint.css('left', 0);
            vPrint.css('transform' , 'none');
            vPrint.css('transform-origin' , '50% 50%');
        }
        else{
            //横屏
            vPrint.width(height);
            vPrint.height(width);
            vPrint.css('top',  (height-width)/2 );
            vPrint.css('left',  0-(height-width)/2 );
            vPrint.css('transform' , 'rotate(90deg)');
            vPrint.css('transform-origin' , '50% 50%');
        }
    }

    export default {

        data() {
            return {
                lessonId: 0,
                currentIndex: 0,
                listEnglishProgramWordGame: [],
                listWordPicture: [],
                ccAudioUrl: "",
                ccInitUrl: "",
                deskBackWidth: 530,
                courseCode: "",
                backgroundColor: "",
                showExitConfirm: 0,
                starAudio:null,
                starCount:0,
                showStarTransition:false,
                totalStarCount:0
            }
        },
        methods: {
            backNav:function(){
                this.showExitConfirm = 1;
            },
            getStarImg(count) {
                let that = this;
                return count <= that.starCount ? require('@/assets/star_score_s.png') : require('@/assets/star_score_n.png');
            },
            playEnded(idMusicmp3) {
                var musicMp3 = document.getElementById(idMusicmp3);

                if (musicMp3 != null) {
                    musicMp3.pause();
                }
            },
            showStarView(count) {
                let that = this;

                that.starCount = count;
                that.starAudio = that.getProgramAudioUrl(that.starCount);
                that.showStarTransition = true;

                setTimeout(() => {
                    for(let i = 1; i <= 3; i++) {
                        $("#star_img_" + i).show(200 + i*350, function(){
                            if (i === 3) {
                                setTimeout(() => {
                                    that.showStarTransition = false;
                                    let starAnimation = $(".star_animation");
                                    starAnimation.show();
                                    starAnimation.animate({top:"20px", right:'30px'}, 500,function(){
                                        starAnimation.hide();
                                        starAnimation.css({top:"", right:""});
                                    });
                                    that.addStar(that.starCount);
                                }, 800);
                            }
                        });
                    }

                    let audioPlayer = document.getElementById('star_audio');

                    if (audioPlayer != null) {
                        audioPlayer.play();
                    }
                }, 200);
            },
            addStar(count) {
                let that = this;
                let url = "englishProgram/addStar/" + that.lessonId + "/" + count;
                this.$axios.get(url).then((response) => {
                    that.totalStarCount = parseInt(response.data);
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            gameQuitClick() {
                this.showExitConfirm = 0;
                this.$router.go(-1);
            },
            gameContinueClick() {
                this.showExitConfirm = 0;
            },
            judgePlatform: function () {
                let that = this;
                // 平台（0-其它平台 1-微信IOS平台 2-微信android平台 3-app平台IOS平台 4-app平台android平台）
                let Platform = 0;
                let token = that.$store.state.token;
                let userid = that.$store.state.userid.toString();

                if (that.isWeixinBrowser()) {
                    // 微信平台
                    if (that.isAppIos()) {
                        Platform = 1;
                    } else {
                        Platform = 2;
                    }
                } else if (!that.isEmpty(token) && !that.isEmpty(userid) && token.length > userid.length) {
                    // app平台
                    if (that.isAppIos()) {
                        Platform = 3;
                    } else {
                        Platform = 4;
                    }
                } else {
                    Platform = 0;
                }

                return Platform;
            },
            showStatus:function (status) {
                let that = this;
                let vPlatform = that.judgePlatform();

                if (vPlatform === 3) {
                    document.location = "readingclubapp:showStatusView:" + status;
                }

                if (vPlatform === 4) {
                    window.note.showStatusView(status);
                }
            },
            getStateHeight: function () {
                return this.getCount(this.$store.state.statusheight);
            },
            getTurnOverBack: function () {
                if (this.courseCode.startsWith("W1-") ||
                    this.courseCode.startsWith("W2-") ||
                    this.courseCode.startsWith("W3-")) {
                    return require("@/TurnBack/" + this.courseCode + "-F.png");
                }

                let vCourseId = this.courseCode.substr(this.courseCode.length - 1);
                return require("@/TurnBack/W-" + vCourseId + "-F.png");
            },
            nextClick: function () {
                let that = this;

                setTimeout(() => {
                    that.showStarView(3);

                    setTimeout(function () {
                        let card = $(".card");
                        card.hide();
                    }, 200);

                    setTimeout(() => {
                        that.nextQuestionClick();
                    }, 3000);
                }, 1500);
            },
            nextQuestionClick: function () {
                let that = this;

                // 判断是否最后一个
                if (that.listEnglishProgramWordGame.length - 1 > that.currentIndex) {
                    that.currentIndex += 1;

                    sessionStorage.setItem("ss", 0);//初始化点击次数
                    sessionStorage.setItem("pp", 0);//初始化已匹配数量
                    sessionStorage.setItem("tt", "xx");//用来判断当前匹配效果是否完成，xx为已完成
                    $(".moves").html(0);//点击次数初始化赋值

                    that.listWordPicture = [];
                    setTimeout(function () {
                        let wordGame = that.listEnglishProgramWordGame[that.currentIndex];
                        that.backgroundColor = wordGame.backgroundColor;
                        that.listWordPicture = wordGame.wordPictureList;
                        that.deskBackWidth = 52 * that.listWordPicture.length;

                        setTimeout(() => {
                            let initAudio = document.getElementById('cc_init_audio');
                            initAudio.play();
                        }, 10);

                        setTimeout(function () {
                            let card = $(".card");
                            card.removeClass("open");
                            card.css("background","url(" + that.getTurnOverBack() + ") no-repeat");
                            card.css("background-size","96px 128px");
                        }, 2500);
                    }, 10);
                } else {
                    this.$router.replace({name: "pConnectLineQuestion", query: {lessonId: this.lessonId}});
                }
            },
            playAudio() {
                let that = this;

                if (that.isEmpty(that.ccAudioUrl)) {
                    return;
                }

                let ccmusicMp3 = document.getElementById('cc_success_audio');
                let playPromise = ccmusicMp3.play();

                if (playPromise !== undefined) {
                    playPromise.then(() => {
                    }).catch((e) => {
                        let vError = JSON.stringify(e);

                        if (!that.isEmpty(vError) && vError !== "{}") {
                            window.console.log("播放失败:playAudio:" + JSON.stringify(e));
                        }
                    });
                } else {
                    window.console.log("播放失败:playAudio");
                }
            },
            fclick(event, pic, audioUrl) {
                let that = this;
                var e = event.currentTarget;

                if ($(e).hasClass("open") || $(e).hasClass("match")) {
                    return false;//如果当前卡片是打开或者已经匹配了的状态则点击无效
                }

                if (sessionStorage.getItem("tt") !== "xx") {
                    return false;//如果匹配效果还未完成点击无效，防止一次点三个
                }

                var audio = document.getElementById('music');
                audio.currentTime = 0;
                audio.play();

                var ss = parseInt(sessionStorage.getItem("ss")) + 1;//点击次数加1
                var pp = parseInt(sessionStorage.getItem("pp"));
                sessionStorage.setItem("ss", ss);
                $(".moves").html(ss);
                $(e).css("background","url(" + that.getWholeThumbnailCut(pic, 192, 256) + ") no-repeat");
                $(e).css("background-size","96px 128px");

                if (parseInt(sessionStorage.getItem("ss")) % 2 === 0) {
                    //如果是第二次点击，则进入匹配机制
                    sessionStorage.setItem("tt", "yy");
                    $(e).addClass("open show open2");//第二个加上open2
                    // window.console.log($(".open1").html());
                    // window.console.log($(".open2").html());

                    if ($(".open1").html() === $(".open2").html()) {  //如果两个里面的html都是一样的  则匹配成功
                        that.ccAudioUrl = that.$qiNiuDomainBase + audioUrl;

                        setTimeout(function () {
                            $(".open1,.open2").addClass("match");
                            $(".open1").removeClass("show open1");
                            $(".open2").removeClass("show open2");
                            that.playAudio();

                            pp = pp + 1;
                            sessionStorage.setItem("tt", "xx");
                            sessionStorage.setItem("pp", pp);

                            if (pp === that.listWordPicture.length/2) { //当匹配成功次数达到，则匹配完成
                                setTimeout(function () {
                                    that.nextClick();
                                }, 500);
                            }
                        }, 500);
                    } else {
                        setTimeout(function () {
                            $(e).css("background","url(" + that.getTurnOverBack() + ") no-repeat");
                            $(e).css("background-size","96px 128px");
                            var e1 = $(".open1");
                            $(e1).css("background","url(" + that.getTurnOverBack() + ") no-repeat");
                            $(e1).css("background-size","96px 128px");
                            //匹配不成功，关闭卡片
                            e1.removeClass("open show open1");
                            $(".open2").removeClass("open show open2");
                            sessionStorage.setItem("tt", "xx");
                        }, 1000);
                    }
                } else {
                    $(e).addClass("open show open1");//第一个加上open1
                }
            },
        },
        mounted() {
            sessionStorage.setItem("ss", 0);//初始化点击次数
            sessionStorage.setItem("pp", 0);//初始化已匹配数量
            sessionStorage.setItem("tt", "xx");//用来判断当前匹配效果是否完成，xx为已完成
            $(".moves").html(0);//点击次数初始化赋值

            let that = this;

            setTimeout(function () {
                let card = $(".card");
                card.removeClass("open");
                card.css("background","url(" + that.getTurnOverBack() + ") no-repeat");
                card.css("background-size","96px 128px");
            }, 2500);
        },
        beforeCreate() {
            let that = this;
            let vLessonId = parseInt(that.$route.query.lessonId);
            let url = "/englishProgram/getTurnOverQuestion/" + vLessonId;

            that.$axios.get(url).then((response) => {
                that.listEnglishProgramWordGame = response.data;
                that.lessonId = vLessonId;

                if (!that.isEmpty(that.listEnglishProgramWordGame)) {
                    let wordGame = that.listEnglishProgramWordGame[0];
                    that.totalStarCount = parseInt(wordGame.totalStarCount);
                    that.listWordPicture = wordGame.wordPictureList;
                    that.courseCode = wordGame.code;
                    that.deskBackWidth = 52 * that.listWordPicture.length;
                    that.backgroundColor = wordGame.backgroundColor;
                    that.ccInitUrl = that.$qiNiuDomainBase + wordGame.fixedQuestionAudio;

                    setTimeout(() => {
                        let initAudio = document.getElementById('cc_init_audio');
                        initAudio.play();
                    }, 10);

                    setTimeout(() => {
                        that.showStatus(0);
                    }, 200);
                }

                setTimeout(() => {
                    transformView();
                }, 200);

            }).catch(function (error) {
                window.console.log(error)
            });
        }
    }
</script>

<style scoped>
    @media screen and (orientation: portrait) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
            overflow: hidden;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: red;
            overflow: hidden;
        }

        #print {
            position: absolute;
            background-color: #f2f2f2;
        }
    }

    @media screen and (orientation: landscape) {
        html {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        body {
            width: 100%;
            height: 100%;
            background-color: white;
        }

        #print {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-color: #f2f2f2;
        }
    }

    .back_nav {
        position: absolute;
        z-index: 999;
        left: 15px;
        top: 15px;
        width: 45px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .back_nav img {
        width: 30px;
        height: 30px;
    }

    .navigation .left i {
        background-color: #0000005a;
        border-radius: 22px;
        font-size: 18px;
        padding: 5px;
    }
    .desk_back {
        width: 530px;
        height: 276px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .desk {
        width: 100%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;
    }

    .desk .card {
        width: 96px;
        height: 128px;
        background-size: 96px 128px;
        font-size: 0;
        color: #ffffff;
        border-radius: 8px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        transform: rotateY(180deg);
        transition: transform 0.5s;
        overflow: hidden;
        z-index: 998;
    }

    .desk .card.open {
        transform: rotateY(360deg);
        cursor: default;
        transition: transform 0.5s;
    }

    .desk .card.show {
        font-size: 33px;
    }

    .desk .card.match {
        cursor: default;
        font-size: 33px;
        animation: fbig 0.5s alternate;
    }

    .fa_common {
        z-index: 999;
        background-size: 100% 100%;
        margin: 5px;
    }
    .card .fa_common img {
        width: 96px;
        height: 128px;
    }

    @keyframes fbig {
        from {
            transform: scale(1)
        }
        to {
            transform: scale(1.1)
        }
    }
    @keyframes zoom {
        0% {
            transform: scale(1);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }
    .big_cat_screen .exit_transition {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.9);
        z-index: 1003;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .big_cat_screen .exit_content {
        position:relative;
    }
    .big_cat_screen .exit_content .exit_title {
        color: white;
        font-size: 18px;
        text-align: center;
        margin-bottom: 50px;
    }
    .big_cat_screen .exit_content .game_action .game_quit {
        display: inline-block;
        margin-right: 100px;
    }
    .big_cat_screen .exit_content .game_action .game_continue {
        display: inline-block;
    }
    .big_cat_screen .exit_content .game_action .game_quit img, .big_cat_screen .exit_content .game_action .game_continue img {
        display: block;
        width: 70px;
        margin-bottom: 10px;
    }
    .big_cat_screen .exit_content .game_action .game_quit span, .big_cat_screen .exit_content .game_action .game_continue span {
        display: block;
        text-align: center;
        font-size: 20px;
        color: white;
    }

</style>
